module.exports = __webpack_public_path__ + "media/educator_advisory_board/David_Duncan-5ab6f1cb.png";